
import Dropbox from "../../../assets/outline/Dropbox.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DropboxIcon({ className, dataTestid = "DropboxIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Dropbox data-testid={dataTestid} className={classes} {...rest} />
  );
}
